import clsx from 'clsx'
import {FC} from 'react'
import {GatewayOption} from '../core/onlinePaymentApi'

type Props = {
  /** The radio group's name, unique on the page. */
  name: string
  gateways: GatewayOption[]
  value?: number
  onChange: (gatewayId: number) => void
  disabled?: boolean
  /** Under the choice when there is more than one: what happens when the chosen gateway refuses. */
  fallbackNote?: string
  className?: string
}

/**
 * The gateways a payment may go through, side by side with their provider's mark; the payer picks one. «پرداخت آنلاین»
 * of an invoice and «شارژ کیف پول» (2026-10-21) show the same choice.
 */
export const GatewayPicker: FC<Props> = ({name, gateways, value, onChange, disabled, fallbackNote, className}) => (
  <fieldset className={className}>
    <legend className='form-label fw-bold fs-6'>درگاه پرداخت</legend>
    <div className='op-gateways' role='radiogroup'>
      {gateways.map((item) => (
        <label key={item.id} className={clsx('op-gateway', {'op-gateway--active': item.id === value})}>
          <input
            type='radio'
            name={name}
            className='visually-hidden'
            checked={item.id === value}
            onChange={() => onChange(item.id)}
            disabled={disabled}
          />
          <span className='op-gateway__badge' style={{background: item.color || undefined}} aria-hidden='true'>
            {item.providerName.slice(0, 1)}
          </span>
          <span className='op-gateway__text'>
            <span className='op-gateway__title'>{item.title}</span>
            {item.title !== item.providerName && <span className='op-gateway__provider'>{item.providerName}</span>}
          </span>
          {item.isSandbox && <span className='badge badge-light-warning'>آزمایشی</span>}
        </label>
      ))}
    </div>
    {gateways.length > 1 && fallbackNote && <div className='text-muted fs-7 mt-2'>{fallbackNote}</div>}
  </fieldset>
)
